module.exports = __webpack_public_path__ + "media/images/new-ui-images/notification-dot-first-8dc080af2573ce3d9eea21312b93f628.svg";